type ScriptOptions = {
  id?: string;
  defer?: boolean;
  attributes?: Record<string, string>;
};

/** Appends an async script to the head and returns it. */
export function injectScript(src: string, { id, defer = false, attributes = {} }: ScriptOptions = {}): HTMLScriptElement {
  const script = document.createElement('script');
  if (id) {
    script.id = id;
  }
  script.async = true;
  script.defer = defer;
  script.src = src;
  Object.entries(attributes).forEach(([name, value]) => script.setAttribute(name, value));
  document.head.appendChild(script);
  return script;
}
